<div class="pt-2 d-flex flex-row">
    <div class="determinate-progressbar d-flex pt-2" style="width: 250px;">
        <label class="text-nowrap">{{percentageComplete}}% completed:</label>
        <mat-progress-bar
            class="ms-4 mt-2"
            mode="determinate"
            [value]="percentageComplete"
            bufferValue="100">
        </mat-progress-bar> 
    </div>
    <div class="determinate-spinner ms-auto- mx-3 d-flex flex-row">
        <mat-spinner style="width: 30px; height: 30px;"
            mode="determinate"
            [value]="deadlineRemain*100/deadlineTotal">
        </mat-spinner>
        <div class="my-auto number" [matTooltip]="TOOLTIP.deadlineRemain(deadlineRemain)">{{deadlineRemain}}</div>
    </div>
</div>